// extracted by css-extract-rspack-plugin
export default {"combobox":"src-app-components-forms-ComboBox-ComboBox-module__combobox-OZ8C_U","selector":"src-app-components-forms-ComboBox-ComboBox-module__selector-KHTcHB","search":"src-app-components-forms-ComboBox-ComboBox-module__search-rKBY5Q","dropdown":"src-app-components-forms-ComboBox-ComboBox-module__dropdown-Cwpb8W","container":"src-app-components-forms-ComboBox-ComboBox-module__container-JBn5WI","view":"src-app-components-forms-ComboBox-ComboBox-module__view-T4T5RT","readonly":"src-app-components-forms-ComboBox-ComboBox-module__readonly-mFUiqb"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"combobox\":\"src-app-components-forms-ComboBox-ComboBox-module__combobox-OZ8C_U\",\"selector\":\"src-app-components-forms-ComboBox-ComboBox-module__selector-KHTcHB\",\"search\":\"src-app-components-forms-ComboBox-ComboBox-module__search-rKBY5Q\",\"dropdown\":\"src-app-components-forms-ComboBox-ComboBox-module__dropdown-Cwpb8W\",\"container\":\"src-app-components-forms-ComboBox-ComboBox-module__container-JBn5WI\",\"view\":\"src-app-components-forms-ComboBox-ComboBox-module__view-T4T5RT\",\"readonly\":\"src-app-components-forms-ComboBox-ComboBox-module__readonly-mFUiqb\"}";
        // 1789362522816
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  